var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selectItems"},_vm._l((_vm.items),function(i,index){return _c('span',{key:i.key,class:{
      activeItem: _vm.active === index,
      inActiveLeft: _vm.active !== index && index == 1,
      inActiveRight: _vm.active !== index && index == 0,
    },on:{"click":function($event){return _vm.handleClick(index, i.key)}}},[_vm._v("\n    "+_vm._s(i.title)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }